// Centralized payment/bank details per NBFC. Loans disbursed by Additri (legacy
// "SM..." loan numbers) still need to be repaid to Additri's account; loans
// disbursed by VN Credits ("SMVN..." loan numbers, or an exceptional "SM..."
// loan flagged by the backend) are repaid to VN Credits' account.
//
// The backend (`Api/ApiController::getLoan`) resolves the correct NBFC per PAN/
// loan and returns it as `nbfc` on the repayment record — use that value as the
// key here rather than deriving it from the loan number on the frontend.

export const NBFC = {
  ADDITRI: "ADDITRI",
  VN_CREDITS: "VN_CREDITS",
};

export const DEFAULT_NBFC = NBFC.VN_CREDITS;

const NBFC_PAYMENT_DETAILS = {
  [NBFC.ADDITRI]: {
    companyName: "ADDITRI SWAYAM SEVA MICRO CREDIT ASSOCIATION",
    bankName: "IDFC FIRST Bank",
    accountNo: "78570996918",
    ifscCode: "IDFB0021601",
    branchAddress: "HISAR BRANCH",
    accountType: "Current",
    swiftCode: "IDFBINBBMUM",
    upiId: "additri@idfcbank",
    upiPayeeName: "ADDITRI SWAYAM SEVA MICRO CREDIT ASSOCIATION",
    buildUpiLink: (amount) =>
      `upi://pay?ver=01&mode=01&orgid=180071&pa=additri@idfcbank&pn=ADDITRI SWAYAM SEVA MICRO CREDIT ASSOCIATION&mc=5734&mid=MID85709969161&mtid=TID85709969161A&qrMedium=04${
        amount ? `&am=${amount}&cu=INR` : ""
      }`,
  },
  [NBFC.VN_CREDITS]: {
    companyName: "V.N. Credits Limited",
    bankName: "ICICI Bank Ltd",
    accountNo: "002105033699",
    ifscCode: "ICIC0000021",
    branchAddress: "Sector 14, Gurgaon",
    accountType: "Current",
    swiftCode: "",
    upiId: "msvncreditslimited.eazypay@icici",
    upiPayeeName: "V.N. CREDITS LIMITED",
    buildUpiLink: (amount) =>
      `upi://pay?pa=msvncreditslimited.eazypay@icici&pn=V.N. CREDITS LIMITED${
        amount ? `&am=${amount}&cu=INR` : ""
      }`,
  },
};

export function getNbfcPaymentDetails(nbfc) {
  return NBFC_PAYMENT_DETAILS[nbfc] || NBFC_PAYMENT_DETAILS[DEFAULT_NBFC];
}
